var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cart__search" }, [
    _c(
      "label",
      { staticClass: "cart__search__label", attrs: { for: "product-search" } },
      [_vm._v("Etsi ja lisää tuote")]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "click-outside",
            rawName: "v-click-outside",
            value: _vm.close,
            expression: "close"
          }
        ],
        staticClass: "cart__search__input-container"
      },
      [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.searchTerm,
              expression: "searchTerm"
            }
          ],
          staticClass:
            "cart__search__input cart__search__input--with-icon cart__search__input--small small",
          attrs: {
            id: "product-search",
            type: "search",
            autocomplete: "new-password",
            placeholder: "Etsi tuotetta"
          },
          domProps: { value: _vm.searchTerm },
          on: {
            keyup: function($event) {
              return _vm.dSearch()
            },
            keydown: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              $event.preventDefault()
              return _vm.search()
            },
            focus: function($event) {
              return _vm.open()
            },
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.searchTerm = $event.target.value
            }
          }
        }),
        _vm._v(" "),
        _vm.searchResults.length > 0 && _vm.showSearchResults
          ? _c(
              "ul",
              { staticClass: "cart__search__results" },
              _vm._l(_vm.searchResults, function(searchResult) {
                return _c(
                  "li",
                  {
                    key: searchResult.id,
                    staticClass: "cart__search__result",
                    attrs: { tabindex: "0" },
                    on: {
                      click: function($event) {
                        return _vm.select(searchResult)
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "cart__search__result-main" }, [
                      _vm._v(
                        _vm._s(searchResult.brand.name) +
                          " " +
                          _vm._s(searchResult.name)
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "cart__search__result-detail" }, [
                      _vm._v(_vm._s(searchResult.sku))
                    ])
                  ]
                )
              }),
              0
            )
          : _vm.showSearchResults && _vm.searchTerm != "" && !_vm.loading
          ? _c("div", { staticClass: "cart__search__results" }, [
              _c("div", { staticClass: "cart__search__no-results" }, [
                _vm._v("\n        Ei tuloksia\n      ")
              ])
            ])
          : _vm.showSearchResults && _vm.loading
          ? _c("div", { staticClass: "cart__search__results" }, [
              _c("div", { staticClass: "cart__search__no-results" }, [
                _vm._v("\n        Ladataan...\n      ")
              ])
            ])
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7f42789c", { render: render, staticRenderFns: staticRenderFns })
  }
}